<div class="container" *ngIf="loadingPage">
  <div class="document-upload-skeleton">
    <ion-skeleton-text animated
      style="width: 72px; height: 18px; border-radius: 10px; margin-bottom: 20px;"></ion-skeleton-text>
    <ion-skeleton-text animated
      style="width: 360px; height: 31px; border-radius: 12px; margin-bottom: 20px;"></ion-skeleton-text>
    <ion-skeleton-text animated
      style="width: 260px; height: 24px; border-radius: 12px; margin-bottom: 10px;"></ion-skeleton-text>
    <ion-skeleton-text animated
      style="width: 100%; height: 42px; border-radius: 12px; margin-bottom: 18px;"></ion-skeleton-text>

    <ion-skeleton-text animated
      style="width: 260px; height: 26px; border-radius: 12px; margin-bottom: 12px;"></ion-skeleton-text>
    <ion-skeleton-text animated
      style="width: 100%; height: 57px; border-radius: 12px; margin-bottom: 10px;"></ion-skeleton-text>
    <ion-skeleton-text animated
      style="width: 100%; height: 57px; border-radius: 12px; margin-bottom: 20px;"></ion-skeleton-text>

    <ion-skeleton-text animated
      style="width: 220px; height: 26px; border-radius: 12px; margin-bottom: 10px;"></ion-skeleton-text>
    <ion-skeleton-text animated
      style="width: 100%; height: 24px; border-radius: 12px; margin-bottom: 10px;"></ion-skeleton-text>
    <ion-skeleton-text animated
      style="width: 100%; height: 57px; border-radius: 12px; margin-bottom: 10px;"></ion-skeleton-text>
    <ion-skeleton-text animated
      style="width: 100%; height: 57px; border-radius: 12px; margin-bottom: 24px;"></ion-skeleton-text>

    <ion-skeleton-text animated
      style="width: 100%; height: 84px; border-radius: 8px; margin-bottom: 28px;"></ion-skeleton-text>
    <ion-skeleton-text animated
      style="width: 40%; height: 48px; border-radius: 8px; margin: 0 auto;"></ion-skeleton-text>
  </div>
</div>

<div class="container" *ngIf="!loadingPage">
  <button type="button" class="btn-back" fill="clear" (click)="goBack()">
    <ion-icon name="arrow-back-outline"></ion-icon>
    <span>Volver</span>
  </button>

  <div class="title-section title">Solicitud de pensión por vejez</div>

  <div class="item-text">
    <p class="sub-title">Carga tu documentación</p>
    <ion-text class="div-text">
      Adjunta los documentos que son necesarios para la solicitud. Solo se admiten
      archivos PDF, JPG y JPEG.
    </ion-text>
    <div class="document-upload-help-row">
      <button type="button" class="link link-button" (click)="openModalDocType()"
        aria-label="¿Qué son estos documentos?">¿Qué son estos documentos?</button>
      <span class="text-mb">Tamaño máximo por documento 10MB</span>
    </div>

    <!-- seccion carga de documentos -->
    <p class="documents-section-title">Documentos personales</p>
    <div class="div-cert">
      <!-- cedula de identidad -->
      <app-document-status [type]="'cedula-de-identidad'" [title]="'Cédula de Identidad'"
        [status]="status['cedula-de-identidad']" [errorMessage]="errorMessages['cedula-de-identidad']"
        (documentType)="setDocumentType($event)" (fileSelected)="onFileSelected($event)"
        (cancelQuery)="cancelQuery($event, 'cedula-de-identidad')"
        (deleteDoc)="delDocument($event)"></app-document-status>

      <!-- certificado de nacimiento -->
      <app-document-status [type]="'nacimiento'" [title]="'Certificado de Nacimiento (*)'" [status]="status.nacimiento"
        [errorMessage]="errorMessages['nacimiento']" (documentType)="setDocumentType($event)"
        (fileSelected)="onFileSelected($event)" (cancelQuery)="cancelQuery($event, 'nacimiento')"
        (deleteDoc)="delDocument($event)"></app-document-status>
    </div>

    <ng-container *ngIf="conyuge || convivienteCivil">
      <p class="documents-section-title">Documentos cónyuge</p>
      <p class="documents-section-description">
        Adjunta certificado de nacimiento del cónyuge y el certificado de matrimonio o union civil según corresponda.
      </p>

      <div class="div-cert">
        <!-- certificado de nacimiento conyuge -->
        <app-document-status [type]="'nacimiento-conyuge'" [title]="'Certificado de Nacimiento Cónyuge (*)'"
          [status]="status['nacimiento-conyuge']" [errorMessage]="errorMessages['nacimiento-conyuge']"
          (documentType)="setDocumentType($event)" (fileSelected)="onFileSelected($event)"
          (cancelQuery)="cancelQuery($event, 'nacimiento-conyuge')" (deleteDoc)="delDocument($event)"
          *ngIf="conyuge"></app-document-status>

        <!-- certificado de nacimiento conviviente civil -->
        <app-document-status [type]="'nacimiento-conyuge'" [title]="'Certificado de Nacimiento Conviviente Civil (*)'"
          [status]="status['nacimiento-conyuge']" [errorMessage]="errorMessages['nacimiento-conyuge']"
          (documentType)="setDocumentType($event)" (fileSelected)="onFileSelected($event)"
          (cancelQuery)="cancelQuery($event, 'nacimiento-conyuge')" (deleteDoc)="delDocument($event)"
          *ngIf="convivienteCivil"></app-document-status>

        <!-- certificado de matrimonio -->
        <app-document-status [type]="'matrimonio'" [title]="'Certificado de Matrimonio (*)'"
          [status]="status.matrimonio" [errorMessage]="errorMessages['matrimonio']"
          (documentType)="setDocumentType($event)" (fileSelected)="onFileSelected($event)"
          (cancelQuery)="cancelQuery($event, 'matrimonio')" (deleteDoc)="delDocument($event)"
          *ngIf="conyuge"></app-document-status>

        <!-- certificado de unión civil -->
        <app-document-status [type]="'union-civil'" [title]="'Certificado de Unión Civil (*)'"
          [status]="status['union-civil']" [errorMessage]="errorMessages['union-civil']"
          (documentType)="setDocumentType($event)" (fileSelected)="onFileSelected($event)"
          (cancelQuery)="cancelQuery($event, 'union-civil')" (deleteDoc)="delDocument($event)"
          *ngIf="convivienteCivil"></app-document-status>
      </div>
    </ng-container>

    <ng-container *ngIf="beneficiarios.length > 0">
      <p class="documents-section-title">Documentos beneficiarios</p>
      <div class="div-cert">
        <ng-container *ngFor="let beneficiario of beneficiarios; let i = index">
          <p class="documents-beneficiary-description">
            Beneficiario {{ i + 1 }}: {{ getNombreCompletoBeneficiario(beneficiario) }}
          </p>
          <app-document-status [type]="beneficiaryDocumentKeys[i]"
            [title]="'Certificado de Nacimiento Beneficiario ' + (i + 1) + ' (*)'"
            [status]="status[beneficiaryDocumentKeys[i]]" [errorMessage]="errorMessages[beneficiaryDocumentKeys[i]]"
            (documentType)="setDocumentType($event)" (fileSelected)="onFileSelected($event)"
            (cancelQuery)="cancelQuery($event, beneficiaryDocumentKeys[i])"
            (deleteDoc)="delDocument($event)"></app-document-status>
        </ng-container>
      </div>
    </ng-container>

    <div class="document-upload-info-box" role="note">
      <div class="document-upload-info-box__icon" aria-hidden="true">
        <icon-info-circle-tramite aria-hidden="true"></icon-info-circle-tramite>
      </div>
      <div class="document-upload-info-box__body">
        <p class="document-upload-info-box__title">¿Te faltan documentos?</p>
        <p class="document-upload-info-box__text">
          Puedes descargarlos en
          <a class="document-upload-info-box__link" (click)="abrirRegistroCivil($event)" rel="noopener noreferrer"
            aria-label="www.registrocivil.cl (abre en nueva pestaña)">
            www.registrocivil.cl
            <ion-icon name="open-outline" class="document-upload-info-box__external-icon" aria-hidden="true"></ion-icon>
          </a>
        </p>
      </div>
    </div>
  </div>

  <div class="document-upload__actions">
    <button class="primary-button primary-button--continue" type="button" [disabled]="btnDisable" (click)="continue()">
      Continuar
    </button>
  </div>
</div>